import { ShieldAlert, AlertTriangle, RefreshCw } from "lucide-react"
import { Button } from "@/components/ui/button"
import { ApiClientError } from "@/lib/api-client"

interface ApiErrorStateProps {
  error: Error | null
  onRetry?: () => void
}

export function ApiErrorState({ error, onRetry }: ApiErrorStateProps) {
  const is403 = error instanceof ApiClientError && error.status === 403

  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-input px-6 py-16">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-muted">
        {is403 ? (
          <ShieldAlert size={24} className="text-orange-500" />
        ) : (
          <AlertTriangle size={24} className="text-red-500" />
        )}
      </div>
      <h3 className="text-base font-semibold text-foreground">
        {is403 ? "Brak uprawnień" : "Wystąpił błąd"}
      </h3>
      <p className="mt-1 text-center text-sm text-muted-foreground">
        {is403
          ? "Nie masz uprawnień do wyświetlenia tej sekcji. Skontaktuj się z administratorem."
          : error?.message || "Nie udało się załadować danych."}
      </p>
      {onRetry && (
        <Button variant="outline" onClick={onRetry} className="mt-5 gap-2">
          <RefreshCw size={14} />
          Spróbuj ponownie
        </Button>
      )}
    </div>
  )
}
